// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-tooltip {
  position: absolute;
  right: 5px;
  bottom: 115%;
  background-color: #555;
  padding: 5px 10px;
  font-size: 14px;
  border-radius: 5px;
  color: #ffffff;
}
.error-tooltip::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #555 transparent transparent transparent;
}
.error-tooltip .span-error::after {
  content: ",";
}
.error-tooltip .span-error:last-child::after {
  content: "";
}

.full-width {
  width: 100%;
}

.form {
  min-width: 300px;
  max-width: 300px;
  width: 100%;
}

.mat-active {
  background-color: #0078d7;
  font-weight: bold;
  color: white;
  right: 0;
}

.mat-noactive {
  background-color: white;
  font-weight: bold;
  color: #0078d7;
  right: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/users/edit-user/folders-list/dialog/dialog.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,sBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;AACF;AAAE;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,sDAAA;AAEN;AACM;EACI,YAAA;AACV;AAEU;EACI,WAAA;AAAd;;AAMA;EACE,WAAA;AAHF;;AAMA;EACE,gBAAA;EACA,gBAAA;EACA,WAAA;AAHF;;AAOA;EACE,yBAAA;EACA,iBAAA;EACA,YAAA;EACA,QAAA;AAJF;;AAOA;EACE,uBAAA;EACA,iBAAA;EACA,cAAA;EACA,QAAA;AAJF","sourcesContent":[".error-tooltip {\r\n  position: absolute;\r\n  right: 5px;\r\n  bottom: 115%;\r\n  background-color: #555;\r\n  padding: 5px 10px;\r\n  font-size: 14px;\r\n  border-radius: 5px;\r\n  color: #ffffff;\r\n  &::after {\r\n      content: \"\";\r\n      position: absolute;\r\n      top: 100%;\r\n      left: 50%;\r\n      margin-left: -5px;\r\n      border-width: 5px;\r\n      border-style: solid;\r\n      border-color: #555 transparent transparent transparent;\r\n  }\r\n  .span-error {\r\n      &::after {\r\n          content: ','\r\n      }\r\n      &:last-child {\r\n          &::after {\r\n              content: ''\r\n          }\r\n      }\r\n  }\r\n}\r\n\r\n.full-width {\r\n  width: 100%;\r\n}\r\n\r\n.form {\r\n  min-width: 300px;\r\n  max-width: 300px;\r\n  width: 100%;\r\n}\r\n\r\n\r\n.mat-active{\r\n  background-color: #0078d7;\r\n  font-weight:bold;\r\n  color:white; \r\n  right:0;\r\n}\r\n\r\n.mat-noactive{\r\n  background-color: #ffff;\r\n  font-weight:bold;\r\n  color:#0078d7; \r\n  right:0;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
